import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@babel+core@7.25.9_@playwright+test@1.48.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@babel+core@7.25.9_@playwright+test@1.48.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@babel+core@7.25.9_@playwright+test@1.48.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@babel+core@7.25.9_@playwright+test@1.48.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/buy-women-built.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/christianna.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/elliott-obatoyinbo-face.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/experts/andy.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/experts/christianna.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/experts/elliot.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/experts/joe.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/experts/katrina.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/experts/mary.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/experts/rownita_marston-mulhearn.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/experts/sam_shashoua.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/founder-mobile.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/founder.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/get-the-gloss.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/hero-bundles/hero-bundle-blue.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/hero-bundles/hero-bundle-green.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/hero-bundles/hero-bundle-pink.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/user.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/logo/full-logo-gradient.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/mary-face.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/InstagramFeedsWidget.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/motion-components/MotionDiv.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionParagraph"] */ "/vercel/path0/src/components/motion-components/MotionParagraph.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionSpan"] */ "/vercel/path0/src/components/motion-components/MotionSpan.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionTitle"] */ "/vercel/path0/src/components/motion-components/MotionTitle.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ReviewsWidgetModern.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/src/components/ui/separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/blog/join-the-community/join-the-community.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/landing/assets/find-us-in/asda.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/landing/assets/find-us-in/boots.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/landing/assets/find-us-in/harrods.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/landing/assets/find-us-in/tesco.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/landing/assets/find-us-in/whole-foods.webp");
;
import(/* webpackMode: "eager", webpackExports: ["FindUsInMarquee"] */ "/vercel/path0/src/features/landing/components/HeroMarquee.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/landing/components/sections/BackedByScience/BackedByScience.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/landing/components/sections/DiscoverOurCollections/DiscoverOurCollections.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/landing/components/sections/GummiesRedefined/GummiesRedefined.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/landing/components/sections/Hero/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/landing/components/sections/LovedBy/LovedBy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPosts"] */ "/vercel/path0/src/features/landing/components/sections/News.tsx/BlogPosts.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/product/components/sections/TrustedByExperts/CardCarousel/CardCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferrerToast"] */ "/vercel/path0/src/hooks/useReferrerToast.tsx");
